const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDj(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 10,
    id: "blue",
    style: {
      fill: "#6ab2e7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 5,
    y: 5,
    id: "green",
    style: {
      fill: "#12ad2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 0,5 0,10 4.330127,7.5 8.660254,5 4.330127,2.5 0,0 z",
    id: "path6904",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3.3143278,3.75 0.3102707,0.954915 1.0040571,0 L 3.8163564,5.295085 4.126627,6.25 3.3143278,5.65983 2.5020286,6.25 2.8122992,5.295085 2,4.704915 l 1.004057,0 L 3.3143278,3.75 z",
    id: "path6929",
    style: {
      fill: "#d7141a"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDj);
export default __webpack_public_path__ + "static/media/dj.5e87c43a2217d43fd88b945a3f945c8a.svg";
export { ForwardRef as ReactComponent };